import { Row } from 'antd';
import { SummarySmallBlock } from '../../../../../components/reusable/CompanyDataCard';
import useFormatDate, { DATE_FORMAT_LONG } from '../../../../../hooks/format/useFormatDate';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useSelector } from 'react-redux';
import { summaryInformation } from '../../../../../store/entities/companySearchResult/selectors/unregisteredReportSelector';
import { handleNegativeClass } from '../helpers';

const SmallBlocks = () => {
  const { t } = useTranslation();
  const formatDate = useFormatDate();

  const { summaryInformation: summaryInformationState } = useSelector(summaryInformation);

  const [manageName, managerPosition] = summaryInformationState?.manager?.managerFullName
    ? summaryInformationState?.manager?.managerFullName.split(', ')
    : '';

  return (
    <div className="space-vertical-sm small-blocks">
      <Row gutter={[30, 30]}>
        <SummarySmallBlock
          blur={t('companyResult.summary.blur.explanation')}
          title={t('companyResult.summary.creditLimit')}
          value={'150k'}
          icon="creditLimit"
        />
        <SummarySmallBlock
          blur={t('companyResult.summary.blur.explanation')}
          explanation={
            summaryInformationState.paidDebts?.total
              ? t('companyResult.summary.paymentHistory.explanation', {
                  amount: summaryInformationState?.paidDebts?.total || '-',
                  date: formatDate(summaryInformationState?.paidDebts?.latestDate),
                  days: summaryInformationState?.paidDebts?.averageDays,
                })
              : false
          }
          title={t('companyResult.summary.paymentHistory')}
          value={summaryInformationState?.paidDebts?.total || t('global.noEntries')}
          negativeClass={
            handleNegativeClass(
              summaryInformationState?.paidDebts?.total,
              summaryInformationState?.paidDebts?.latestDate
            ) || summaryInformationState?.paidDebts?.activeDebts
          }
          icon="paymentHistory"
        />
        <SummarySmallBlock
          blur={t('companyResult.summary.blur.explanation')}
          explanation={
            summaryInformationState?.companyStatistics?.lastHalfYear
              ? t('companyResult.summary.reportNumbers.value', {
                  reports1: summaryInformationState?.companyStatistics?.lastMonth,
                  reports2: summaryInformationState?.companyStatistics?.lastQuarter,
                  reports3: summaryInformationState?.companyStatistics?.lastHalfYear,
                })
              : false
          }
          title={t('companyResult.summary.reportNumbers')}
          value={summaryInformationState?.companyStatistics?.lastHalfYear || t('global.noEntries')}
          icon="reportNumbers"
        />
        <SummarySmallBlock
          blur={t('companyResult.summary.blur.explanation')}
          title={t('companyResult.summary.unreliableCompanies')}
          value={summaryInformationState?.unreliableCompanies?.total || t('global.noEntries')}
          icon="negativeInformation"
          negativeClass={handleNegativeClass(
            summaryInformationState?.unreliableCompanies?.total,
            summaryInformationState?.unreliableCompanies?.latestDate
          )}
        />
        <SummarySmallBlock
          title={t('companyResult.summary.legalStatus')}
          value={
            summaryInformationState?.status ? (
              <div className={summaryInformationState?.statusCode === 1 ? 'color-success' : 'color-secondary'}>
                {summaryInformationState?.status}
              </div>
            ) : (
              t('global.noEntries')
            )
          }
          icon="legalStatus"
        />
        <SummarySmallBlock
          value={managerPosition ? manageName : t('global.noEntries')}
          title={managerPosition || t('companyResult.summary.manager')}
          icon="manager"
        />
        <SummarySmallBlock
          explanation={
            summaryInformationState?.employeeNumber
              ? t('companyResult.summary.employeesNumber.explanation', {
                  date: summaryInformationState?.employeeNumberDate
                    ? formatDate(summaryInformationState?.employeeNumberDate, DATE_FORMAT_LONG)
                    : '-',
                })
              : false
          }
          title={t('companyResult.summary.employeesNumber')}
          value={summaryInformationState?.employeeNumber || t('global.noEntries')}
          icon="employeeNumber"
        />
        <SummarySmallBlock
          explanation={
            summaryInformationState?.legalProceeding?.total
              ? t('companyResult.summary.courtHearings.explanation', {
                  totalDefendant: summaryInformationState?.legalProceeding?.totalDefendant || t('global.noEntries'),
                  latestDate: summaryInformationState?.legalProceeding?.latestDate
                    ? formatDate(summaryInformationState?.legalProceeding?.latestDate, DATE_FORMAT_LONG)
                    : '-',
                })
              : false
          }
          title={t('companyResult.summary.courtHearings')}
          value={summaryInformationState?.legalProceeding?.total || t('global.noEntries')}
          icon="legalProceedings"
          negativeClass={handleNegativeClass(
            summaryInformationState?.legalProceeding?.totalDefendant,
            summaryInformationState?.legalProceeding?.latestDateDefendant
          )}
        />
      </Row>
    </div>
  );
};

export default SmallBlocks;
